import React, { useState } from "react";
import axios from "axios";
import { Box } from "@mui/system";
import { Add as AddIcon, CloudUpload } from "@mui/icons-material";
import {
  Button,
  Fab,
  styled,
  TextField,
  Tooltip,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withStyles
} from "@mui/material";

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

function Add() {

  const [open, setOpen] = useState(false);

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [fileName, setFileName] = useState('');
  const [imageFile, setImageFile] = useState(null); 

  const titleChange = (e) => setTitle(e.target.value);
  const contentChange = (e) => setContent(e.target.value);
  const imageFileChange = (e) => {

    setFileName(e.target.files[0].name);
    setImageFile(e.target.files[0]);

    console.log(e.target.files[0].name);
    console.log(e.target.files[0]);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  
  const handleClose = () => {
    setTitle('');
    setContent('');
    setFileName('');
    setImageFile(null);
    setOpen(false);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const url = '/api/contents';
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    const formData = new FormData();
    formData.append('title', title);
    formData.append('file', fileName);
    formData.append('image', imageFile);
    formData.append('content', content);

    axios.post(url, formData, config)
    .then((res) => {
      handleClose();
    })
    .catch((err) => {
      console.log(err);
    })
  };

  return (
    <React.Fragment>

      <Tooltip
        onClick={handleOpen}
        title="Add"
        sx={{
          position: "fixed",
          bottom: 20,
          right: { xs: "calc(50% - 25px)", md: 30 },
        }}
      >
        <Fab size="medium" color="primary" aria-label="add">
          <AddIcon />
        </Fab>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleClose}
        onSubmit={onSubmit}
        PaperProps={{
          component: 'form',
          sx: { borderRadius: 3 }
        }}
      >
        <DialogTitle>Upload Content</DialogTitle>

        <DialogContent>

          <Button 
            fullWidth
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
          >
            {fileName !== '' ? (
              <>{fileName}</>
            ) : (
              <CloudUpload />
            )}
            <VisuallyHiddenInput 
              type="file"
              id="image"
              name="image"
              onChange={imageFileChange}
              accept="image/*"
            />
          </Button>

          <TextField 
            fullWidth
            type="text"
            size="small"
            margin="normal"
            name="title"
            label="Title"
            value={title}
            onChange={titleChange}
          />

          <TextField
            fullWidth
            multiline
            rows={6}
            size="small"
            type="text"
            margin="normal"
            name="content"
            label="Text"
            value={content}
            onChange={contentChange}
          />

        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" type="submit" sx={{ borderRadius: 1 }}>POST</Button>
          <Button variant="contained" color="error" onClick={handleClose} sx={{ borderRadius: 1 }}>CANCEL</Button>
        </DialogActions> 
      </Dialog>
    </React.Fragment>
  );
}

export default Add;